/**
 * agentApplicationService.js
 * All API calls for the Agent Application wizard.
 * Base: /api/applications/
 */

import { api } from '../../api';
import apiRoutes from '../../api/apiRoutes';

export const submitApplication = (formData) =>
    api.post(apiRoutes.applications.list, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);

export const getMyApplications = () =>
    api.get(apiRoutes.applications.mine).then(r => r.data);

export const getApplication = (id) =>
    api.get(apiRoutes.applications.detail(id)).then(r => r.data);

export const withdrawApplication = (id) =>
    api.post(apiRoutes.applications.withdraw(id)).then(r => r.data);

export const addDocument = (id, formData) =>
    api.post(apiRoutes.applications.documents(id), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data);

/**
 * Find existing user by national_id or create a new account.
 * Returns { access, refresh, user_id, first_name, last_name, phone, email, national_id }
 */
export const agentApplicantAuth = (payload) =>
    api.post(apiRoutes.applications.applicantAuth, payload).then(r => r.data);

export const fetchNeighborhoods = (cityName) =>
    api.get(apiRoutes.locations.neighborhoods, { params: { city_name: cityName, page_size: 100 } })
        .then(r => r.data?.results ?? r.data);

export const fetchProvinces = () =>
    api.get(apiRoutes.locations.provinces).then(r => r.data?.results ?? r.data);

export const fetchCities = (provinceId) =>
    api.get(apiRoutes.locations.provinceCities(provinceId))
        .then(r => r.data?.results ?? r.data);
